import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Hitrust is the Rustacean open source community organization from Harbin Institute of Technology.
If you are interested in operating systems, command-line tools, WebAssembly, distributed systems, databases, blockchain, microservices, edge computing, DevOps, embedded devices, audio and video analytics and transcoding, cryptocurrencies, the Internet of Things, etc., and would like to explore new possibilities, or if you are interested in Functional Programming, Type Theory, etc., and would like to take a practical intro, then join Hitrust and grow with us!`}</p>
    </blockquote>
    <p>{`Join `}<a parentName="p" {...{
        "href": "https://discord.com/invite/dHJCEsC"
      }}>{`Discord Server`}</a>{` to discuss with each other.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      